import { useStore } from '@/store';
import { useIsomorphicLayoutEffect } from 'framer-motion';

export function useLayout(theme: 'white' | 'blue') {
  const setTheme = useStore((state) => state.setHeaderTheme);
  useIsomorphicLayoutEffect(() => setTheme(theme), [setTheme, theme]);
}
